import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_PROGRAM_ORDER_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_PROGRAM_ORDER_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_PROGRAM_ORDER_DETAIL_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/user-program-orders/${id}`,
    method: 'GET',
  })
);

export default apiCall;
